<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="page-title text-center">支付成果金额</div>
            <div class="alert-area" v-if="info.is_overrun === 1">
                <el-alert
                    :closable="false"
                    title="该服务人员单月结算额已超限，继续结算将支付超额服务费，请确认。"
                    type="error">
                </el-alert>
            </div>
            <div class="page-caption">
                <div class="cell">
                    <div class="cell__label">项目名称：</div>
                    <div class="cell__value">{{info.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">服务人员：</div>
                    <div class="cell__value">{{info.member}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">预计完成时间：</div>
                    <div class="cell__value">{{info.complete_time}}</div>
                </div>
            </div>
            <div class="page-content">
                <div class="caption">
                    <div class="cell">服务内容</div>
                    <div class="cell">单位</div>
                    <div class="cell">服务要求</div>
                    <div class="cell">确认数量</div>
                    <div class="cell">确认单价</div>
                    <div class="cell">奖励金额</div>
                    <div class="cell">服务合计</div>
                </div>
                <div class="box" v-for="(item, index) in info.service" :key="index">
                    <div class="cell">
                        <el-tooltip :content="item.name">
                            <div class="content-ellipsis">{{item.name}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.unit}}</div>
                    <div class="cell">
                        <el-tooltip :content="item.demand">
                            <div class="content-ellipsis">{{item.demand}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.amount}}</div>
                    <div class="cell">{{item.price}}</div>
                    <div class="cell">
                        {{item.award}}
                    </div>
                    <div class="cell">{{item.money}}</div>
                </div>
                <div class="box no-top-border">
                    <div class="cell">服务总计</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.to_pay_money}}</div>
                </div>
                <!-- <div class="box">
                    <div class="cell">已支付</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.pay_money}}</div>
                </div> -->
                <!-- <div class="box">
                    <div class="cell">待支付项目金额</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.to_pay_money}}</div>
                </div> -->
                <div class="box">
                    <div class="cell">平台综合服务费</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.to_pay_fee}}</div>
                </div>
                <div class="box">
                    <div class="cell">待支付总额</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.to_pay}}</div>
                </div>
            </div>
            <div class="page-footer">
                <div class="handler-wraper">
                    <el-button type="default" style="margin-right: 20px;"
                               @click="goBack">返回
                    </el-button>
                    <el-button type="primary" @click="onCommit">去支付</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router'

export default {
    name: 'ServicePayInfo',
    inject: ['goPage'],
    data () {
        return {
            userInfo: {},
            info: {
                service: []
            }
        }
    },
    mounted () {
        this.getUserInfo()
        this.getInfo(this.$route.query.id, this.$route.query.sub_id, this.$route.query.pre_id)
    },
    methods: {
        goBack () {
            if (this.userInfo.role_id === 3) {
                router.replace(`/index/pay/prepaid`)
            } else {
                router.replace(`/index/project/detail?id=${this.$route.query.id}&panel=1`)
            }
        },
        getInfo (id, sub_id, pre_id) {
            this.$http.get('/api/user/project/subpayinfo', {
                params: {
                    id,
                    sub_id,
                    pre_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        onCommit () {
            router.replace(`/index/project/servicepay?id=${this.info.id}&sub_id=${this.info.sub_id}&pre_id=${this.info.pre_id}`)
        },
        getUserInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";

    .page-title {
        padding-top: 43px;
        font-size: 20px;
        font-weight: bold;
    }

    .alert-area {
        margin-top: 25px;
        padding: 0 20px;
        margin-bottom: -10px;
    }

    .page-caption {
        display: flex;
        margin-top: 25px;
        margin-bottom: 15px;
        padding: 0 20px;

        .cell {
            flex: 1;
            display: flex;

            &:nth-child(2) {
                justify-content: center;
            }

            &:last-child {
                justify-content: flex-end;
            }
        }
    }

    .page-content {
        padding: 0 20px;

        .caption {
            display: flex;
            background-color: #F5F5FA;
            color: #909399;
            border-bottom: 1px solid $--border-color-base;
            border-top: 1px solid $--border-color-base;
        }

        .box {
            display: flex;
            border-bottom: 1px solid $--border-color-base;
        }

        .cell {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 48px;
            padding-left: 10px;
            display: flex;
            align-items: center;

            &:nth-child(1) {
                width: 150px;
            }

            &:nth-child(2) {
                width: 100px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 100px;
            }

            &:nth-child(5) {
                width: 150px;
            }

            &:nth-child(6) {
                width: 150px;
            }

            &:nth-child(7) {
                width: 100px;
            }
        }
    }

    .page-footer {
        .handler-wraper {
            width: 322px;
            margin: 138px auto 0;

            button {
                width: 144px;
            }
        }
    }
</style>
